import { Grid, Tabs, Tab, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
// import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
// import { useStores } from '../../../stores';

export interface TabSelectionProps {
  selectedTabIndex: number;
  setSelectedTabIndex: Function;
  margin?: string;
  tabList?: (string | React.JSX.Element)[];
  recommendationFetched?: boolean;
}

const TabSelection: React.FC<TabSelectionProps> = ({
  selectedTabIndex,
  setSelectedTabIndex,
  margin,
  tabList,
   
  recommendationFetched,
}) => {
  const useStyles = makeStyles()((theme) => ({
    tabsRoot: {
      minHeight: '33px',
      height: '33px',
    },
    tab: {
      textTransform: 'none',
      minHeight: '33px',
      height: '33px',
      minWidth: 'fit-content',
      width: 'fit-content',
      padding: '0px',
    },
    selectedTab: {
      color: `${patientAccessTheme.palette.text.highemphasis} !important`,
    },
    avatarStyling: {
      backgroundColor: '#E0E9F9',
      marginLeft: '8px',
      marginTop: '2px',
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  }));

  const { classes } = useStyles();

  const constants = componentConstants.MOLECULES.TAB_SELECTION;

  // const recommendedTabStore = useStores().recommendedTabStore;

  // const RecommendationsLabel = () => {
  //   return (
  //     <Grid container direction="row">
  //       <Grid item>
  //         <Typography>{constants.RECOMMENDATIONS}</Typography>
  //       </Grid>
  //       {/* undefined used because not implemented for all pages. will be removed afterwards. */}
  //       {recommendationFetched === undefined ||
  //         (recommendationFetched && (
  //           <Grid item>
  //             <Avatar className={classes.avatarStyling}>
  //               <Typography
  //                 fontSize="11px"
  //                 fontType="medium"
  //                 lineHeight="12px"
  //                 textColor="#353F6AFA"
  //               >
  //                 {recommendedTabStore.totalRecommendedCategories}
  //               </Typography>
  //             </Avatar>
  //           </Grid>
  //         ))}
  //     </Grid>
  //   );
  // };
  // const employerGroupStore = useStores().employerGroupStore;
  // const eg_nid_list = employerGroupStore.employerGroupResponseData?.eg_nid;
  const tabs = tabList ?? [constants.OVERVIEW];
  // (eg_nid_list.length > 1
  //   ? [constants.OVERVIEW]
  //   : [constants.OVERVIEW, <RecommendationsLabel />]);
  return (
    <Grid style={{ width: '100%', margin: margin ?? '18px 0px 0px 0px' }}>
      <Tabs
        value={selectedTabIndex}
        onChange={(event: React.ChangeEvent<{}>, index: number) => {
          setSelectedTabIndex(index);
        }}
        indicatorColor="primary"
        textColor="secondary"
        className={classes.tabsRoot}
      >
        {tabs.map((label, index: number) => (
          <Tab
            key={index}
            label={label}
            className={classes.tab}
            classes={{
              selected: classes.selectedTab,
            }}
            style={{ marginRight: '49px' }}
          />
        ))}
      </Tabs>
      <Divider
        style={{ backgroundColor: patientAccessTheme.palette.grey[300] }}
      />
    </Grid>
  );
};

export default TabSelection;
